import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import defaultProps from './default-props';

const propsSchema = [
  {
    key: 'raceCalendar',
    label: 'Race Calendar',
    type: types.ARRAY,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.RICHTEXT
      },
      {
        key: 'description',
        label: 'Description',
        type: types.RICHTEXT
      },
      {
        key: 'dates',
        label: 'Dates',
        type: types.ARRAY,
        children: [
          {
            key: 'date',
            label: 'Date',
            type: types.TEXT
          },
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT
          },
          {
            key: 'description',
            label: 'Description',
            type: types.TEXTAREA
          },
          {
            key: 'rounds',
            label: 'Rounds',
            type: types.ARRAY,
            children: [
              {
                key: 'number',
                label: 'Number',
                type: types.TEXT,
              }
            ]
          }
        ]
      },
      {
        key: 'moreURL',
        label: 'More Info URL',
        type: types.TEXT
      }
    ]
  }
];

export default {
  title: 'Formula E Calendar',
  id: 'FormulaECalendar',
  propsSchema,
  defaultProps
};
